module.exports = __webpack_public_path__ + "img/ddos.b80a40b.svg";